import { Injectable } from '@angular/core';

import { manutencoesProgramadaStorage } from "./data.service";

@Injectable()
export class ManutencaoProgramadaService {

    constructor(
    ) { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(manutencoesProgramadaStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(manutencoesProgramadaStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(manutencoesProgramadaStorage + "-new");
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/manutencao-programada/shared/manutencao-programada.service.ts
 **/